import { Badge } from '@/shared/components';

interface Props {
  is_elevated?: boolean;
  is_internal?: boolean;
}

export function RoleFlags({ is_elevated, is_internal }: Props) {
  return (
    <>
      {is_elevated && <Badge variant="warning">Elevated</Badge>}
      {is_internal && <Badge variant="outline">Internal</Badge>}
    </>
  );
}
